/** Roles eligible to own CRM records (leads/deals/etc.) — the salespeople.
 *  Drives the owner pickers & filters so they list only sales staff. Matches
 *  the backend role titles (`users` RBAC). */
export const CRM_OWNER_ROLES = ['Founder', 'Sales Manager'] as const;
